// microsoft-ads-enhanced-conversion.js - 公共抽离代码（无Liquid变量，可复用）

/**
 * Microsoft Ads 官方步骤
设置增强转化
说明:
1.实现脚本。复制下面的代码片段,并将其粘贴到要跟踪的页面<head>和</head>标记之间J紧跟基本 UET标记。
2.标准化数据。为了保护您客户的隐私,您文件中的个人客户数据(电子邮件地址)必须加密或散列。为了标准化散列结果,请在散列之前遵循以下格式规则。
?按照E.164标准格式化电话号码
?对于电子邮件:
。删除电子邮件地址中的所有空格和重音符号(例如:a)
。删除"+"和"@"之间的所有内容(例如,name+withplus@outlook.con(viname@outlook.com)
。删除任何在"@"之前的句号,并确保它不以句号结尾(例如,ex.ample@outleook.com.变成example@outlook.com)
。请确保文本是小写字母,并且电子邮件地址包含"@"符号
3.(可选)对数据进行哈希。如果我们检测到个人客户数据没有经过哈希,我们会在收集之前对其进行哈希。你也可以使用SHAA-256算法自己对这些数据进行哈希。
如果你不确定如何手动操作,你也可以将这些指令发送给一个开发者。
<script>
   // Add this script right after your base UET tag code
   window.uetq = window.uetq || [];
   window.uetq.push('set', { 'pid': { 
      'em': 'contoso@example.com', // Replace with the variable that holds the user's email address. 
      'ph': '+14250000000', // Replace with the variable that holds the user's phone number. 
   } });
</script>
*/

(function(window) {
  // 1. 全局初始化uetq，防止基础标签加载失败报错
  window.uetq = window.uetq || [];

  // 2. 数据标准化辅助函数（公共复用，与之前一致）
  /**
   * 标准化邮箱地址（按 Microsoft Ads 官方要求）
   * @param {string} email - 原始邮箱（由页面模板传入）
   * @returns {string} 标准化后的邮箱
   */
  function standardizeEmail(email) {
    if (!email || typeof email !== 'string') return '';
    
    let standardized = email
      .trim()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\+[^@]+@/g, '@');
    
    const [localPart, domainPart] = standardized.split('@');
    if (!localPart || !domainPart) return '';
    const cleanedLocalPart = localPart.replace(/\./g, '').replace(/\.$/, '');
    standardized = `${cleanedLocalPart}@${domainPart}`;
    
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(standardized) ? standardized : '';
  }

  /**
   * 标准化电话号码（按 E.164 标准）
   * @param {string} phone - 原始电话（由页面模板传入）
   * @returns {string} 标准化后的电话
   */
  function standardizePhone(phone) {
    if (!phone || typeof phone !== 'string') return '';
    
    let standardized = phone.replace(/[^0-9+]/g, '');
    return standardized.startsWith('+') ? standardized : '';
  }

  // 3. 通用推送函数（接收页面传入的邮箱/电话，统一处理推送）
  /**
   * 推送增强转化数据到 Microsoft Ads
   * @param {string} userEmail - 页面模板传入的动态邮箱
   * @param {string} userPhone - 页面模板传入的动态电话
   */
  window.pushMicrosoftEnhancedConversion = function(userEmail, userPhone) {
    // 标准化页面传入的动态数据
    const standardizedEm = standardizeEmail(userEmail);
    const standardizedPh = standardizePhone(userPhone);
    // console.log("standardizedEm, standardizedPh:",standardizedEm, standardizedPh);

    // 仅有效数据时推送，避免空值
    const pidData = {};
    if (standardizedEm) pidData.em = standardizedEm;
    if (standardizedPh) pidData.ph = standardizedPh;

    if (Object.keys(pidData).length > 0) {
      window.uetq.push('set', { 'pid': pidData });
    }
  };
})(window);